// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__1kXnL","text":"SelectPayment_text__2_6jw","title":"SelectPayment_title__2FalI","btn":"SelectPayment_btn__37HQH"};